import i18n                 from 'i18next';
import * as React           from 'react';
import { useTranslation }   from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { reduxForm }        from 'redux-form';

import RenderButton            from '../../../../../../components/buttons/base/RenderButton';
import { RenderCheckboxField } from '../../../../../../components/fields/redux/RenderCheckboxField';
import { RenderPhoneField }    from '../../../../../../components/fields/redux/RenderPhoneField';
import { RenderTextField }     from '../../../../../../components/fields/redux/RenderTextField';
import { useCommon }           from '../../../../../../providers/common';
import { useModal }            from '../../../../../../providers/modal';

import type { CompletedProjectOrderFormProps } from './completed-project.order.form.props';

const CompletedProjectOrderForm: React.FC<CompletedProjectOrderFormProps> = function(props) {
  const history = useHistory();
  const { t }   = useTranslation();

  const {
          handleSubmit,
          submitForm,
          valid,
        } = props;

  const common: any = useCommon();
  const modal: any  = useModal();

  const agreementPage        = React.useMemo(() => {
    const page = common.pages.find((page: any) => {
      return page.template === 'policy-personal-data';
    });

    if (!page) {
      return;
    }

    return `/${page.urlKey}`;
  }, [common.pages]);
  const completedProjectPage = React.useMemo(() => {
    const page = common.pages.find((page: any) => page.template === 'completed-project');

    if (!page) {
      return '';
    }

    return `/${page.urlKey}`;
  }, [common.pages]);

  const handleClose = React.useCallback(() => {
    modal.hideModal();

    if (completedProjectPage) {
      history.replace(completedProjectPage);
    }
  }, [completedProjectPage]);

  if (!agreementPage) {
    return null;
  }

  return (
    <form
      name={'CompletedProjectForm'}
      noValidate={true}
      method={'post'}
      onSubmit={(event) => {
        submitForm(event, handleSubmit, valid);
      }}
    >
      <RenderTextField
        autoComplete={'off'}
        name={'name'}
        placeholder={`${t('client_name')}`}
        required
      />
      <RenderPhoneField
        autoComplete={'off'}
        hiddenMask
        name={'phone'}
        placeholder={`${t('client_phone')}`}
        required
      />
      <p className={'required_fields'}>{t('client_required_fields')}</p>
      <div className={'agreement'}>
        <RenderCheckboxField
          autoComplete={'off'}
          label={(
            <span className={'agreement_wrapper'}>
              {t('сlient_agreement')}{' '}
              <Link
                onClick={handleClose}
                to={agreementPage}
              >{t('client_agreement_processingOfPersonalData')}</Link>
            </span>
          )}
          name={'agreement'}
        />
      </div>
      <div className={'buttonsContainer'}>
        <RenderButton
          action={handleClose}
          label={t('btn_cancel')}
        />
        <RenderButton
          className={'fill'}
          label={t('client_sendRequest')}
          type={'submit'}
        />
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'CompletedProjectForm',
  validate(values: any) {
    const errors: any = {};

    if (!values.agreement) {
      errors.agreement = i18n.t('validation_error_agreement_required');
    }

    if (!values.name) {
      errors.name = i18n.t('validation_error_name_required');
    }

    if (!values.phone || values.phone.includes('_') || values.phone.length < 7) {
      errors.phone = i18n.t('validation_error_phone_required');
    }

    return errors;
  },
  // @ts-ignore
})(CompletedProjectOrderForm);